import React, { useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';
import { useMapsLibrary } from '@vis.gl/react-google-maps';

const AddressAutocomplete = ({ onPlaceSelect }) => {
  const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
  const inputRef = useRef(null);
  const places = useMapsLibrary('places');

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      fields: ['formatted_address', 'geometry', 'name']
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener('place_changed', () => {
      const place = placeAutocomplete.getPlace();
      onPlaceSelect(place);
    });
  }, [onPlaceSelect, placeAutocomplete]);

  return (
    <TextField
      label='Enter your address'
      variant='outlined'
      fullWidth
      inputRef={inputRef}
      required
      placeholder='Enter your address'
    />
  );
};

export default AddressAutocomplete;
